"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

exports.default = capitalizeString;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/internalHelpers/_capitalizeString.js
// module id = 59
// module chunks = 22676092666560 221374088121123